import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

declare var $: any;
import * as _ from 'lodash';
import { AlertService } from 'src/app/services/alert.service';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  constructor(private router: Router,private location: Location, private alertService: AlertService) { }

  ngOnInit() {
    console.log("✅ AlertComponent initialized");
    this.alertService.register(this);
  }
  success(message) {
      $('#alertSuccessMessage2').html(message);
      $('#success-alert2').modal('show');
      $('.modal-dialog').draggable({
        handle: ".modal-header"
      });
      
    }
    
    note(message) {
    
      $('#noteSuccessMessage2').html(message);
      $('#note-alert2').modal('show');
      $('.modal-dialog').draggable({
        handle: ".modal-header"
      });

      
      
    }

    note1(message, onOk: () => void) {
    
      $('#noteSuccessMessage2').html(message);
      $('#note-alert2').modal('show');
      $('.modal-dialog').draggable({
        handle: ".modal-header"
      });

      $('#note-alert2 .btn-ok').off('click').on('click', () => {
        onOk();
      });
      
    }

    notifyMeeting(message, onOk: () => void, onClose: ()=> void) {
    
      $('#noteMeetingMessage').html(message);
      $('#note-alert3').modal({ backdrop: false, keyboard: false, show: true });

 

      $('#note-alert3 .btn-ok').off('click').on('click', () => {
        onOk();
      });

      $('#note-alert3 .btn-ok1').off('click').on('click', () => {
        onClose();
      });
      
    }
    
    successWithOk(message, onOK: string) {
     
      $("#route2").val(onOK);
      $('#alertSuccessMessage2').html(message);
      $('#success-alert2').modal('show');
     
    }
    successWithOk1(message: string, onOk: () => void) {
      $('#alertSuccessMessage').html(message);
      $('#success-alert').modal('show');
    
      $('#success-alert .btn-ok').off('click').on('click', () => {
        onOk();
      });
    }
  

    onOkFunction() {

      let route = $("#route2").val();
      if (route == undefined || route == "" || route == null || route == "null") {
        return true;
      } else {
        if(route.includes('/ncd-issue/edit/')){
    
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate([route]));
        }else{
          this.router.navigate(['structure',
          { outlets: { 'structure-outlet': route} }]);
          // this.location.back(); // Navigate back to the previous page
    
        }
        
      }
    
    }

    error1(message: string, onOk?: () => void) {
      $('#alertErrorMessage2').html(message);
      $('#error-alert2').modal('show');
    
      $('.modal-dialog').draggable({
        handle: '.modal-header'
      });
    
      // Unbind previous click handlers and bind the new one
      $('#error-alert2 .btn-ok').off('click').on('click', () => {
        $('#error-alert22').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        if (onOk) {             
          onOk(); // Call the provided callback
        }
      });
    }
    
    
    errorWithOk(message, onOK: string) {
      $("#route2").val(onOK);
      $('#alertErrorMessage2').html(message);
      $('#error-alert2').modal('show');
     
    }
    
    error(message) {
    
      $('#alertErrorMessage2').html(message);
      $('#error-alert2').modal('show');
      $('.modal-dialog').draggable({
        handle: ".modal-header"
      });
    }
    
    
    }
    
